export default [
  { id: "#path5419", d: "M73.9,526.8l-5.2-43.9l59.8,42.5L73.9,526.8z" },
  { id: "#path4232", d: "M108.8,482.8l-40.1,0.3l59.8,42.5L108.8,482.8z" },
  { id: "#path4236", d: "M73.9,526.8L50,470.9l18.7,12L73.9,526.8z" },
  { id: "#path4240", d: "M68.7,483l40.1-0.3l38.7-59L68.7,483z" },
  { id: "#path4244", d: "M68.7,483L50,470.9l71.6-147.6L68.7,483z" },
  { id: "#path4248", d: "M147.6,423.8L68.7,483l52.9-159.7L147.6,423.8z" },
  { id: "#path4252", d: "M119.7,245.9l1.9,77.4l-15.9-47L119.7,245.9z" },
  { id: "#path4628", d: "M105.6,276.4l-30.8,58.5l46.6-11.6L105.6,276.4z" },
  { id: "#path4632", d: "M119.7,245.9L137,254l-15.4,69.3L119.7,245.9z" },
  { id: "#path4634", d: "M121.6,323.3l-40.4,25.9l-6.3-14.3L121.6,323.3z" },
  { id: "#path4636", d: "M121.6,323.3l-40.4,25.9L50,470.9L121.6,323.3z" },
  { id: "#path4644", d: "M266.1,526.8H175l7-33.7L266.1,526.8z" },
  { id: "#path4646", d: "M182,493.2l84,33.7L233.9,483L182,493.2z" },
  { id: "#path4648", d: "M195.8,429.1l38.1,53.9l-51.9,10.2L195.8,429.1z" },
  { id: "#path4656", d: "M147.6,423.8l98.7,10.8l-46.7-29.3L147.6,423.8z" },
  { id: "#path4658", d: "M121.6,323.3l77.9,82.1L147.5,424L121.6,323.3z" },
  { id: "#path4660", d: "M199.5,405.5l46.7,29.3l11.5-123.6L199.5,405.5z" },
  { id: "#path4662", d: "M246.3,434.6l-12.4,48.3L195.8,429L246.3,434.6z" },
  { id: "#path4672", d: "M257.7,311l-136.1,12.3l77.9,82.1L257.7,311z" },
  { id: "#path4674", d: "M119.7,245.9l105.7-70.3L137,254L119.7,245.9z" },
  { id: "#path4676", d: "M225.3,175.7l18.3,37.7L136.8,254L225.3,175.7z" },
  { id: "#path4678", d: "M257.7,311l-136.1,12.3L137,254L257.7,311z" },
  { id: "#path4688", d: "M243.7,213.5l14.1,97.6l-120.9-57L243.7,213.5z" },
  { id: "#path4690", d: "M257.7,311l-14.1-97.5L381,279.6L257.7,311z" },
  { id: "#path4692", d: "M304.1,191l-78.8-15.3l18.3,37.7L304.1,191z" },
  { id: "#path4694", d: "M243.7,213.5l60.4-22.4l77,88.5L243.7,213.5z" },
  { id: "#path4704", d: "M257.7,309.5l-9.6,104.1l93.4-18.8L257.7,309.5z" },
  { id: "#path4706", d: "M381,279.5l-39.4,115.3l-83.9-83.9L381,279.5z" },
  { id: "#path4708", d: "M304.1,191H398l-172.7-15.3L304.1,191z" },
  { id: "#path4729", d: "M381,279.5l-77-88.5H398L381,279.5z" },
  { id: "#path4731", d: "M393.5,390.5L381,279.6l-39.4,115.3L393.5,390.5z" },
  { id: "#path4735", d: "M423.9,170.9L398.1,191l58.4,13.7L423.9,170.9z" },
  { id: "#path4743", d: "M456.4,204.7l-75.4,74.8L398,191L456.4,204.7z" },
  { id: "#path4747", d: "M406,507.4l-9.3-87.4l-32.8,19.7L406,507.4z" },
  {
    id: "#path4749",
    d: "M527.4,279.5l-102.9,50.2L381,279.5C381,279.5,527.4,279.5,527.4,279.5z"
  },
  { id: "#path4755", d: "M556.7,204.7l16.5,39.1l-3.9-68.1L556.7,204.7z" },
  { id: "#path4757", d: "M498.4,515.3l35.4-36.2l12.9,28.3L498.4,515.3z" },
  { id: "#path4776", d: "M533.7,479.1l-34.4,14.1l9-65.8L533.7,479.1z" },
  { id: "#path4778", d: "M533.7,479.1l-35.4,36.2l0.9-22.2L533.7,479.1z" },
  { id: "#path4780", d: "M396.7,419.9l39.9,28.5L406,507.2L396.7,419.9z" },
  { id: "#path4799", d: "M508.3,427.4l-9,65.8l-102.6-73.3L508.3,427.4z" },
  { id: "#path4801", d: "M385.7,405.5l11.1,14.6l-32.8,19.7L385.7,405.5z" },
  { id: "#path4818", d: "M508.3,427.4l22.2,3.6l16.1,76.3L508.3,427.4z" },
  { id: "#path4820", d: "M406,507.4l30.7-58.8l-8,44.7L406,507.4z" },
  { id: "#path4822", d: "M424.6,329.8l74.7,19.1l28.3-69.3L424.6,329.8z" },
  { id: "#path4824", d: "M499.3,348.9l-6.8,35.1l-67.9-54.3L499.3,348.9z" },
  { id: "#path4860", d: "M508.3,427.4l-83.7-97.6l-27.9,90.2L508.3,427.4z" },
  { id: "#path4862", d: "M406,507.4l52.5,21.7l-29.7-35.8L406,507.4z" },
  { id: "#path4864", d: "M385.7,405.5l-139.3,29.3l1.9-20.9L385.7,405.5z" },
  { id: "#path4866", d: "M424.6,329.8l-27.9,90.2L381,279.5L424.6,329.8z" },
  { id: "#path4880", d: "M456.4,204.7h100.4l-132.9-33.8L456.4,204.7z" },
  { id: "#path4961", d: "M406,507.4l52.5,21.7l-71.2-2.1L406,507.4z" },
  { id: "#path5128", d: "M406,507.4l-18.8,19.5L364,439.7L406,507.4z" },
  { id: "#path5130", d: "M195.8,429.1l-48.2-5.3l27.4,103L195.8,429.1z" },
  { id: "#path5136", d: "M508.3,427.4l-15.9-43.3l38.1,47.1L508.3,427.4z" },
  { id: "#path5138", d: "M631,341.1l19-26.8l-10.6-1.7L631,341.1z" },
  { id: "#path5140", d: "M424.6,329.8l83.7,97.6l-15.9-43.3L424.6,329.8z" },
  { id: "#path5142", d: "M499.3,348.9l28.3-69.3l16,46.3L499.3,348.9z" },
  { id: "#path5144", d: "M579.4,218.1l-9.9-42.4l3.9,68.1L579.4,218.1z" },
  { id: "#path5166", d: "M593.1,325.9l-65.7-46.3l16,46.3H593.1z" },
  { id: "#path5168", d: "M612.1,284.2l19,56.9l8.4-28.5L612.1,284.2z" },
  { id: "#path5170", d: "M631,341.1l-37.9-15.3l19-41.7L631,341.1z" },
  { id: "#path5172", d: "M593.1,325.9l-65.7-46.3l84.6,4.5L593.1,325.9z" },
  { id: "#path5174", d: "M543.6,325.9l5.2,12.2l44.4-12.2H543.6z" },
  { id: "#path5176", d: "M499.3,348.9l44.3-23.1l5.2,12.2L499.3,348.9z" },
  { id: "#path5186", d: "M527.4,279.5l84.6,4.5l-38.7-40.3L527.4,279.5z" },
  { id: "#path5188", d: "M573.3,243.8l41,8.9l-2.3,31.5L573.3,243.8z" },
  { id: "#path5190", d: "M579.4,218.1l4.7-32l-14.6-10.4L579.4,218.1z" },
  { id: "#path5200", d: "M579.4,218.1l8.3-9.6l-3.7-22.4L579.4,218.1z" },
  { id: "#path5202", d: "M650,314.2l-37.9-30.1l27.4,28.4L650,314.2z" },
  { id: "#path5204", d: "M627,283.7l23,30.5l-37.9-30.1L627,283.7z" },
  { id: "#path5206", d: "M573.3,243.8l6.1-25.7l35.1,34.6L573.3,243.8z" },
  {
    id: "#path5208",
    d: "M614.3,252.7l-2.3,31.5l13.7-31.5C625.7,252.7,614.3,252.7,614.3,252.7z"
  },
  { id: "#path5258", d: "M612.1,284.2l13.7-31.5l1.4,31L612.1,284.2z" },
  { id: "#path5260", d: "M593.1,325.9l37.9,15.3l-82.3-3.1L593.1,325.9z" },
  { id: "#path5262", d: "M625.7,252.7l-46.3-34.6l35.1,34.6H625.7z" },
  { id: "#path5270", d: "M587.7,208.6l38.1,44.1l-46.5-34.6L587.7,208.6z" },
  { id: "#path5272", d: "M81.1,349.2l-6.2-14.3L53,336.3L81.1,349.2z" },
  { id: "#path5286", d: "M81.1,349.2l-6.2-14.3l46.6-11.6L81.1,349.2z" },
  { id: "#path5288", d: "M398,191l25.8-20.1l-198.5,4.8L398,191z" },
  { id: "#path5296", d: "M579.4,218.1l-9.9-42.4l14.6,10.4L579.4,218.1z" },
  { id: "#path5298", d: "M246.3,434.6l139.3-29.3l-137.4,8.3L246.3,434.6z" },
  { id: "#path5306", d: "M625.7,252.7l-38.1-44.1l-8.2,9.5L625.7,252.7z" },
  { id: "#path5310", d: "M398,191l25.8-20.1l-198.5,4.8L398,191z" },
  { id: "#path5316", d: "M393.5,390.5l-51.9,4.5l44,10.5L393.5,390.5z" },
  { id: "#path5324", d: "M508.3,427.4l22.2,3.6l-38.1-47.1L508.3,427.4z" },
  { id: "#path5341", d: "M543.6,325.9l5.2,12.2l-49.5,10.8L543.6,325.9z" },
  { id: "#path5343", d: "M182,493.2l-7,33.7h91.1L182,493.2z" },
  { id: "#path5345", d: "M393.5,390.5l-7.9,15l11.1,14.6L393.5,390.5z" },
  { id: "#path5357", d: "M650,314.2l-10.6-1.7L631,341L650,314.2z" },
  { id: "#path5359", d: "M68.7,483l5.2,43.9l54.6-1.4L68.7,483z" },
  { id: "#path5361", d: "M248.3,413.7l137.4-8.3l-44-10.5L248.3,413.7z" },
  { id: "#path4733", d: "M381,279.5l75.4-74.8l71.1,74.8H381z" },
  { id: "#path4878", d: "M573.3,243.8l-45.9,35.7l29.3-74.8L573.3,243.8z" },
  { id: "#path4858", d: "M456.4,204.7h100.4l-29.3,74.8L456.4,204.7z" }
];
